// Un seul composant pour tous les types de questions. Chaque champ a son
// label lié, son aide décrite et son état d'erreur annoncé : c'est ce qui
// fait la différence entre un formulaire utilisable et un formulaire subi.
export default function Champ({ champ, valeur, onChange, manquant, faute }) {
  const id = 'champ-' + champ.varname
  const aide = champ.hint ? id + '-aide' : undefined

  if (champ.type === 'title') return <h2 className="section">{champ.label}</h2>
  if (champ.type === 'comment') return <p className="explication">{champ.hint || champ.label}</p>

  const commun = {
    id, 'aria-describedby': aide, 'aria-invalid': manquant || !!faute || undefined,
    required: champ.required,
  }

  let controle
  switch (champ.type) {
    case 'text':
    case 'address':
      controle = <textarea {...commun} rows={champ.type === 'address' ? 3 : 5}
                           value={valeur || ''} onChange={(e) => onChange(e.target.value)} />
      break
    case 'select':
      controle = (
        <select {...commun} value={valeur || ''} onChange={(e) => onChange(e.target.value)}>
          <option value="">Choisir…</option>
          {champ.options.map((o) => <option key={o}>{o}</option>)}
        </select>
      )
      break
    case 'radio':
      return (
        <fieldset className={`champ ${manquant || faute ? 'manquant' : ''}`}>
          <legend>{champ.label}{champ.required && <span aria-hidden="true"> *</span>}</legend>
          {champ.hint && <p className="aide" id={aide}>{champ.hint}</p>}
          {champ.exemple && !faute && <p className="exemple">Exemple : {champ.exemple}</p>}
          {faute && <p className="faute" role="alert">{faute}</p>}
          {champ.options.map((o) => (
            <label className="case" key={o}>
              <input type="radio" name={champ.varname} checked={valeur === o}
                     onChange={() => onChange(o)} />{o}
            </label>
          ))}
        </fieldset>
      )
    case 'checkbox':
      return (
        <div className={`champ ${manquant || faute ? 'manquant' : ''}`}>
          <label className="case">
            <input type="checkbox" id={id} checked={valeur === 'Oui'}
                   aria-describedby={aide}
                   onChange={(e) => onChange(e.target.checked ? 'Oui' : 'Non')} />
            {champ.label}
          </label>
          {champ.hint && <p className="aide" id={aide}>{champ.hint}</p>}
          {champ.exemple && !faute && <p className="exemple">Exemple : {champ.exemple}</p>}
          {faute && <p className="faute" role="alert">{faute}</p>}
        </div>
      )
    case 'checkboxes': {
      const liste = Array.isArray(valeur) ? valeur : []
      return (
        <fieldset className={`champ ${manquant || faute ? 'manquant' : ''}`}>
          <legend>{champ.label}{champ.required && <span aria-hidden="true"> *</span>}</legend>
          {champ.hint && <p className="aide" id={aide}>{champ.hint}</p>}
          {champ.exemple && !faute && <p className="exemple">Exemple : {champ.exemple}</p>}
          {faute && <p className="faute" role="alert">{faute}</p>}
          {champ.options.map((o) => (
            <label className="case" key={o}>
              <input type="checkbox" checked={liste.includes(o)}
                     onChange={(e) => onChange(e.target.checked
                       ? [...liste, o] : liste.filter((x) => x !== o))} />{o}
            </label>
          ))}
        </fieldset>
      )
    }
    case 'file':
      controle = <input {...commun} type="file"
                        onChange={(e) => onChange(e.target.files[0]?.name || '')} />
      break
    default:
      controle = <input {...commun} type={{ email: 'email', tel: 'tel', number: 'number', date: 'date' }[champ.type] || 'text'}
                        value={valeur || ''} onChange={(e) => onChange(e.target.value)} />
  }

  return (
    <div className={`champ ${manquant || faute ? 'manquant' : ''}`}>
      <label htmlFor={id}>{champ.label}{champ.required && <span aria-hidden="true"> *</span>}</label>
      {champ.hint && <p className="aide" id={aide}>{champ.hint}</p>}
          {champ.exemple && !faute && <p className="exemple">Exemple : {champ.exemple}</p>}
          {faute && <p className="faute" role="alert">{faute}</p>}
      {controle}
      {manquant && <p className="erreur-champ" role="alert">Cette réponse est nécessaire.</p>}
    </div>
  )
}
